import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import routes from '../routes.js'
import API from '@/utils/http'

// 全局注册
import 'vant/lib/index.css';
Vue.config.productionTip = false
Vue.use(Vant);

Vue.prototype.$API = API

new Vue({
  render: h => h(App),
  router: routes
}).$mount('#app')